import BatchManagerContainer from "../../container/admin/batch-manager";

const BatchManager = () => {
    return <BatchManagerContainer />;
};

export default BatchManager;